import { Button, Card, Grid, Text } from '@mantine/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import { setKlaviyoAccount } from '../../store/klaviyoSlice';
import ErrorMessage from '../ErrorMessage';

const KlaviyoDisconnectButton = () => {
  const fetch = useFetch();
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);
  const { accountId, domainId } = useParams();

  // Redux is the single owner of the account state - the settings page mirrors it via
  // useEffect, so clearing it here is all a disconnect needs.
  const logout = async () => {
    setError(undefined);
    setDisabled(true);
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/klaviyo/logout`, {
      method: 'POST',
    })
      .then(() => {
        dispatch(setKlaviyoAccount(null));
      })
      .catch(() => {
        setError('Klaviyo disconnect failed, please try again later or contact support!');
      });
  };

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>
              Connection
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Button variant="filled" onClick={() => logout().finally(() => setDisabled(false))} disabled={disabled}>
              Disconnect Klaviyo from Releva
            </Button>

            <ErrorMessage message={error} />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default KlaviyoDisconnectButton;
